import { render, staticRenderFns } from "./UiDataTable.vue?vue&type=template&id=fbf59034&scoped=true&"
import script from "./UiDataTable.vue?vue&type=script&lang=ts&"
export * from "./UiDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./UiDataTable.vue?vue&type=style&index=0&id=fbf59034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf59034",
  null
  
)

export default component.exports